import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HotelsBoxService {
  hotelSelected: EventEmitter<any> = new EventEmitter<any>();

  updateHotelsData(data: any) {
    const hotelData = {
      id: data.id,
      gid: "HOT_" + data.id,
      name: data.main_text,
      city: data.destination_city,
    }
    this.hotelSelected.emit(hotelData);
  }
}
